import React from "react";
import { useAuth } from '../auth/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaHome } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from '../images/aplogo.png'; // Adjust path if necessary

const navButtonClass =
  "px-4 py-2 text-sm text-gray-600 hover:text-white hover:bg-blue-600 rounded-md transition-colors border border-gray-300 hover:border-blue-600";

const CDTopNav = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem('authRole');
    const showSubscriberBackLink = role === 'wallet_superadmin' || role === 'wallet_finance';
    const showAnchorListLink = location.pathname.startsWith('/partner-detail');

    const pathname = location?.pathname || '';
    const isPartnerDetail = pathname.startsWith('/partner-detail');
    const partnerDetailSegments = pathname.split('/').filter(Boolean);
    const isSubanchorDetail = isPartnerDetail && partnerDetailSegments.length >= 3;
    const anchorIdFromPath = isPartnerDetail && partnerDetailSegments[1] ? partnerDetailSegments[1] : null;

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200">
            {/* Top Row: Logo and Logout */}
            <div className="flex justify-between items-center px-4 py-2">
                <img src={logo} alt="Logo" className="h-10 w-auto" />
                {!showSubscriberBackLink && (
                    <button
                        onClick={handleLogout}
                        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-colors"
                    >
                        Logout
                    </button>
                )}
            </div>

            {/* Second Row: Navigation Links */}
            <div className="flex items-center px-4 py-2 space-x-3 flex-wrap gap-2">
                {showSubscriberBackLink ? (
                    <>
                        <button
                            type="button"
                            onClick={() => navigate('/subscriber-wallet')}
                            className={navButtonClass}
                        >
                            ← Back to Home
                        </button>
                        {isPartnerDetail && (
                            <>
                                <button
                                    type="button"
                                    onClick={() => navigate('/financedashboard')}
                                    className={navButtonClass}
                                >
                                    ← Back to Anchor List
                                </button>
                                {isSubanchorDetail && anchorIdFromPath && (
                                    <button
                                        type="button"
                                        onClick={() => navigate(`/partner-detail/${anchorIdFromPath}`)}
                                        className={navButtonClass}
                                    >
                                        ← Back
                                    </button>
                                )}
                            </>
                        )}
                    </>
                ) : (
                  <>
                  <Link
                      to="/financedashboard"
                      className="flex items-center px-3 py-1 rounded-md bg-gray-100 text-black font-semibold hover:bg-gray-200 transition"
                  >
                      <FaHome className="mr-2" />
                      Home
                  </Link>
                  </>
                )}
                {showAnchorListLink && (
                    <button
                        type="button"
                        onClick={() => navigate('/financedashboard')}
                        className="px-4 py-2 text-sm text-gray-600 hover:text-white hover:bg-blue-600 rounded-md transition-colors border border-gray-300 hover:border-blue-600"
                    >
                        ← Anchor List
                    </button>
                )}
            </div>
        </div>
    );
};

export default CDTopNav;
